import React, { useEffect, useState } from 'react';
import { useForm } from "react-hook-form";
import axios from 'axios';
import qs from 'qs';
import Access from "./Components/Access";
import Navbar from "./Components/Navbar";
import { rescueHtml } from './Components/Tools';
import FeedPopulation from "./Parametres/Parametres_COM_EPCI/Population";
import UploadLogoOrganisme from './Components/UploadLogoOrganisme';
import UploadTamponSignature from './Parametres/Parametres_EPFL/UploadTamponSignature';
import OrganismeAdresse from './Components/OrganismeAdresse';
import OrganismeRib from './Components/OrganismeRib';
import OrganismePiedPage from './Components/OrganismePiedPage';
import OrganismeCoordonnees from './Components/OrganismeCoordonnees';
import PresentationAccueil from './Img/Presentation-accueil.png';
import Logo from './Img/Logo_projets&finances.png';

const Organismepage = (props) =>
{
    const [budgets, setBudgets] = useState([]);
    const [budget, setBudget] = useState([]);
    const [nomen, setNomen] = useState(null);
    const [organisme, setOrganisme] = useState(null);
    const [phrasesAccueil, setPhrasesAccueil] = useState([]);
    
    const purple = '#6571FE';

    // More robust typewriter effect: uses chained setTimeout and a ref for the index
    const Typewriter = ({ text, speed = 40 }) => {
        const [display, setDisplay] = useState('');
        const indexRef = React.useRef(0);
        const timeoutRef = React.useRef(null);

        useEffect(() => {
            // cleanup any pending timeout
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            }
            if (!text) {
                setDisplay('');
                indexRef.current = 0;
                return;
            }
            setDisplay('');
            indexRef.current = 0;

            const tick = () => {
                const i = indexRef.current;
                if (i >= text.length) {
                    timeoutRef.current = null;
                    return;
                }
                // append the next character
                setDisplay((prev) => prev + text.charAt(i));
                indexRef.current = i + 1;
                timeoutRef.current = setTimeout(tick, speed);
            };

            timeoutRef.current = setTimeout(tick, speed);

            return () => {
                if (timeoutRef.current) clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            };
        }, [text, speed]);

        return <span>{display}</span>;
    };

    async function mount()
    {
        if (!props.user) {
            await props.getUser()
        }
        else {
            // Récupération du budget de l'utilisateur
            const params = {
                'getBudgets': true,
                'id': props.user.id_budget
            }
            await axios.post('https://app-slfinance.fr/api/budgets.php', qs.stringify(params))
            .then(async (res) => {
                await setBudget(res.data[0])
            })
            .catch((err) => {
                console.warn(err)
            })
            
            /* Récupération du nomen du budget */
            await axios.get("https://app-slfinance.fr/api/config_budget.php?id_budget="+props.user.id_budget)
            .then(async (res) => {
                await res.data.forEach(async element => {
                    if (element[2] === 'nomen') {
                        var tmp = element[3].split(';');
                        await tmp.pop();
                        await setNomen(tmp);
                    }
                });
            })
            .catch((err) => {
                console.warn(err)
            })

            // Récupération des budgets de l'organisme
            await axios.get("https://app-slfinance.fr/api/budgets.php?id_organisme="+props.user.id_organisme+'&list=true')
            .then(async (result) => {
                var tmp = []
                var i = 1
                await result.data.forEach(async budget => {
                    tmp[i] = {
                        'id_budget': budget.id,
                        'budget_annexe': budget.budget_annexe,
                        'nom': rescueHtml(budget.nom),
                        'siret': budget.siret
                    }
                    i++;
                });
                await setBudgets(tmp);
            })
            .catch((err) => {
                console.warn(err)
            })

            // récuperation des informations de l'organisme
            await axios.post("https://app-slfinance.fr/api/organismes.php", qs.stringify({'getOrganismes': true, 'id': props.user.id_organisme}))
            .then(async (res) => {
                await setOrganisme(res.data);
            })
            .catch((err) => {
                console.warn(err)
            })

            // Récupération des phrases d'accueil
            await axios.post('https://app-slfinance.fr/api/messages_accueil.php', qs.stringify({'get': true}))
            .then((res) => {
                if (Array.isArray(res.data)) {
                    setPhrasesAccueil(res.data);
                }
            })
            .catch((err) => console.warn(err));
        }
    }

    useEffect(() =>
    {
        mount();
    }, [props.user])


    // Resultat du formulaire
    const { register, handleSubmit } = useForm();
    
    const onSubmit = async data => {
        if (data.id_budget)
        {
            const params = {
                'id': props.user.id,
                'id_budget': data.id_budget,
                'updateUser': true
            };
            axios.post('https://app-slfinance.fr/api/connexion.php', qs.stringify(params))
            .then(() => {
                window.location = window.location.href
            })
            .catch((err) => {
                console.warn(err)
            })
        }
    };


	return (
        <Access needConnection={true}  type_user={[2, 3]}>
            <Navbar user={props.user} />
            {props.user?
            // Exceptionnellement enlever un marginTop négatif pour avoir une page blanche complète
            <div style={{backgroundColor: 'white', marginTop: -8}}> 
                <div style={{display: 'flex', margin: 10}}>
                    
                    <div style={{flex: 1}}>
                        <div style={{flex: 1, margin: 20, display: 'flex'}}>
                            <p style={{color: purple}}>Réglages</p>
                            <p style={{color: purple}}>\</p>
                            <p style={{color: purple, fontWeight: 'bold', marginLeft: 5}}>{rescueHtml(props.user.nom_organisme)}</p>
                            <p style={{color: purple, marginLeft: 5}}>({props.user.nomen})</p>
                        </div>
                    </div>

                    <div style={{flex: 1, textAlign: 'center', margin: 20}}>
                        <form style={{flex: 1}} onChange={handleSubmit(onSubmit)}>
                            <select className='shadow-md' style={{padding: 12, fontSize: 18, minWidth: 320, height: 50, borderRadius: 8}} {...register("id_budget")}>
                                <option value={props.user.id_budget}>{rescueHtml(props.user.nom_budget)}</option>
                                {budgets.map((budget, id) =>
                                <option key={id} value={budget['id_budget']}>{budget['nom']}</option>
                                )}
                            </select>
                        </form>
                    </div>

                    <div style={{flex: 1, textAlign: 'center', marginRight: 10, marginLeft: 10}}>
                        {phrasesAccueil && phrasesAccueil.length > 0 &&
                        <div style={{margin: 20, fontStyle: 'italic', color: purple, fontSize: 20}}>
                            <Typewriter text={phrasesAccueil[Math.floor(Math.random() * phrasesAccueil.length)]?.message || ''} speed={40} />
                        </div>
                        }
                    </div>
                </div>

                <div style={{margin: 60, justifyContent: 'center', alignItems: 'center'}}>
                    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <img src={Logo} alt="Logo Projets & Finances" style={{maxWidth: '400px', height: 'auto'}} />
                    </div>
                    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 50}}>
                        <img src={PresentationAccueil} alt="Présentation Accueil" style={{maxWidth: '70%', height: 'auto'}} />
                    </div>
                </div>
            </div>
            :null}
        </Access>
	);
}

export default Organismepage;
